export default "__VITE_ASSET__D4t2tnc$__"